import BaseApi from './base/BaseApi';

/**
 * Файл КП поставщика (ТЗ 4.2 «Загрузить файл КП»): привязка уже загруженного файла к запросу.
 * Ответ — файл КП с заданием сопоставления; с признаком «вместо подтверждения» (`replacedItem`)
 * то же действие заменяет выбранный отклик (ТЗ 2.8). Сгенерировано Claude.
 */
export default class SpecQuoteFileApi extends BaseApi {
  static entityName = 'spec_quote_files';
}
